module.exports = ['indexes.subscription_needed.title', 'indexes.subscription_needed.buy_btn', 'indexes.subscription_needed.or', 'indexes.subscription_needed.login'];
